import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { DocumentoTipoRequisito, eEstadoDocumento, eEstadoTipoVisita, ParametrosMaestro } from 'src/app/models/common/enumModel';
import { ConfiguracionDocumentoCreateModel } from 'src/app/models/configuracion-documento/ConfiguracionDocumentoCreateModel';
import { ConfiguracionDocumentoModel } from 'src/app/models/configuracion-documento/ConfiguracionDocumentoModel';
import { IConfiguracionDocumentoCreateModel } from 'src/app/models/interfaces/configuracion-documento/IConfiguracionDocumentoCreateModel';
import { IConfiguracionDocumentoModel } from 'src/app/models/interfaces/configuracion-documento/IConfiguracionDocumentoModel';
import { IMaestroDocumentoModel } from 'src/app/models/interfaces/maestro-documento/IMaestroDocumentoModel';
import { ITipoVisitaModel } from 'src/app/models/interfaces/tipo-visita/ITipoVisitaModel';
import { FilterMaestroDocumentoModel } from 'src/app/models/maestro-documento/FilterMaestroDocumentoModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { FilterTipoVisitaModel } from 'src/app/models/tipo-visita/FilterTipoVisitaModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ConfiguracionDocumentoService } from 'src/app/services/configuracion-documento/configuracion-documento.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { MaestroDocumentosService } from 'src/app/services/maestro-documentos/maestro-documentos.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { TipoVisitaService } from 'src/app/services/tipo-visita/tipo-visita.service';

@Component({
  selector: 'app-configuracion-documento-registrar',
  templateUrl: './configuracion-documento-registrar.component.html',
  styleUrls: ['./configuracion-documento-registrar.component.css']
})
export class ConfiguracionDocumentoRegistrarComponent implements OnInit {
  model: IConfiguracionDocumentoCreateModel = new ConfiguracionDocumentoCreateModel();
  listaTipoRequisitos: ParametroModel[] = new Array<ParametroModel>();
  listaMaestroDocumentos: IMaestroDocumentoModel[] = new Array<IMaestroDocumentoModel>();
  listaTipoVisitas: ITipoVisitaModel[] = new Array<ITipoVisitaModel>();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();

  constructor(
    private router: Router,
    private maestroDocumentoService: MaestroDocumentosService,
    private tipoVisitaService: TipoVisitaService,
    private configuracionDocumentoService: ConfiguracionDocumentoService,
    private serviceParametros: ParametroService,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
  ) { 
  }

  ngOnInit(): void {
    this.serviceParametros.getDetalles(ParametrosMaestro.TIPO_REQUISITO).subscribe((data) => {
      this.listaTipoRequisitos = data.items;
    });

    this.serviceParametros.getDetalles(ParametrosMaestro.ESTADO_CONFIG_DOCUMENTO).subscribe((data) => {
      this.listaEstados = data.items;
    });

    let filterMaestroDocumentos = new FilterMaestroDocumentoModel();
    filterMaestroDocumentos.idEstado = eEstadoDocumento.ACTIVO;
    this.maestroDocumentoService.getList(filterMaestroDocumentos).subscribe((data) => {
      this.listaMaestroDocumentos = data;
    });

    let filterTipoVisita = new FilterTipoVisitaModel();
    filterTipoVisita.idEstado = eEstadoTipoVisita.ACTIVO;
    this.tipoVisitaService.getList(filterTipoVisita).subscribe((data) => {
      this.listaTipoVisitas = data;
    });
  }

  onSubmit(form: NgForm) {
    if (!form.invalid) {  
      this.confirmDialogService.open('¿Deseas guardar los cambios?'); //options
      this.confirmDialogService.confirmed().subscribe((confirmed) => {
        if (confirmed) {
          this.configuracionDocumentoService.submit(this.model).subscribe((data) => {
            this.alertDialogService.open("El documento fue registrado");
            this.router.navigate(['/configuracion', 'documentos']);  
          });
        }
      });
    }
  }

  // changeControlarFechas(e: any): void {
  //   if(!this.model.controlarFechas){
  //     this.model.restringeAccesos = false;
  //   }
  // }
  changeRestringeAccessos(e: any): void {
    if(this.model.restringeAccesos){
      this.model.controlarFechas = true;
      this.model.esPredeterminado = true;
      this.model.idRequisito = DocumentoTipoRequisito.TODOS;
    }
  }
}
